/* eslint-disable no-shadow */
import React, { useState, useEffect, useContext } from 'react';
import { swalMessages, permitsList } from 'src/constants';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { getUnidades } from 'src/services/insightService';
import Changes from '../../pages/InsigthFactory/Changes/Changes';
import { getHistory, acceptAndReject } from '../../services/insightChangesServices';
import { Context } from '../../context/Contex';
import * as paths from '../../routes/paths';

const ChangesContainer = () => {
  const [historyList, setHistoryList] = useState([]);
  const [units, setUnits] = useState([]);
  const [openResult, setOpenResult] = useState(false);
  const [result, setResult] = useState({});
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];
  const history = useHistory();

  const fetchHistory = async () => {
    const { success, data } = await getHistory();
    if (success) {
      setHistoryList(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };
  const fetchUnits = async () => {
    const { success, data } = await getUnidades();
    if (success) {
      setUnits(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onAcceptChange = (rowData) => {
    swal(swalMessages.ACCEPT_CONFIRM).then(async (willConfirm) => {
      if (willConfirm) {
        const { success } = await acceptAndReject({
          tipo: 'aprobar',
          id: rowData.id,
        });
        if (success) {
          const updatedTestAccept = historyList.filter(
            (history) => history.id !== rowData.id,
          );
          swal(swalMessages.SUCCESSFUL_APPROVAL);
          setHistoryList(updatedTestAccept);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const onRejectChange = (rowData) => {
    swal(swalMessages.REJECT_CONFIRM).then(async (willConfirm) => {
      if (willConfirm) {
        const { success } = await acceptAndReject({
          tipo: 'rechazar',
          id: rowData.id,
        });
        if (success) {
          const updatedTestAccept = historyList.filter(
            (test) => test.id !== rowData.id,
          );
          swal(swalMessages.SUCCESFUL_REJECT);
          setHistoryList(updatedTestAccept);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };
  const onOpenResult = (rowData) => {
    setResult(rowData);
    setOpenResult(true);
  };
  const onCloseResult = () => {
    setOpenResult(false);
  };

  const withoutPermit = (permit) => {
    if (permit < 4) {
      history.push('/insight_factory');
    } else {
      return null;
    }
  };

  const onClickReturn = () => {
    history.push(paths.INSIGHT_FACTORY);
  };

  useEffect(() => {
    withoutPermit(permitValue);
    fetchHistory();
    fetchUnits();
  }, []);

  return (
    <Changes
      units={units}
      result={result}
      openResult={openResult}
      historyList={historyList}
      onOpenResult={onOpenResult}
      onCloseResult={onCloseResult}
      onRejectChange={onRejectChange}
      onAcceptChange={onAcceptChange}
      onClickReturn={onClickReturn}
    />
  );
};

export default ChangesContainer;
